module.exports = __webpack_public_path__ + "img/takenicon.5d69aceb.svg";